import React, { createContext, useState, useContext } from "react";

const LanguageContext = createContext();

export const translations = {
  tr: {
    // Navbar
    home: "Ana Sayfa",
    travelAgency: "Travel Agency",
    onlineReservation: "Online Rezervasyon",
    agencyForm: "Acenta Formu",
    hotels: "Oteller",
    international: "Yurtdışı",
    services: "Hizmetlerimiz",
    contact: "İletişim",
    dubai: "Dubai",
    cyprus: "Kıbrıs",

    // Home Page
    heroTitle: "SunKiss ile Hayalinizdeki Tatili Keşfedin",
    heroSubtitle:
      "Türkiye'nin en güzel destinasyonlarında ve Antalya'da unutulmaz anılar biriktirin",
    exploreMore: "Keşfet",
    featuredHotels: "Öne Çıkan Oteller",
    popularDestinations: "Popüler Destinasyonlar",
    viewDetails: "Detayları Gör",

    // Hotels
    selectCity: "Şehir Seçin",
    hotelsIn: "Otelleri",
    perNight: "Gecelik",
    stars: "Yıldız",

    // Dubai
    dubaiSpecial: "Dubai Özel",
    dubaiSubTitle:
      "Dubai'nin en güzel destinasyonlarında unutulmaz anılar biriktirin",
    dubaiHotels: "Dubai Otelleri",
    dubaiTours: "Dubai Turları",
    dubaiTransfer: "Dubai Transfer",
    dubaiVisa: "Dubai Vize",

    // Cyprus
    cyprusSpecial: "Kıbrıs Özel",
    cyprusSubTitle:
      "Kıbrıs'ın en güzel destinasyonlarında unutulmaz anılar biriktirin",
    cyprusHotels: "Kıbrıs Otelleri",
    cyprusTours: "Kıbrıs Turları",
    cyprusTransfer: "Kıbrıs Transfer",
    cyprusVisa: "Kıbrıs Vize",

    // Services
    ourServices: "Hizmetlerimiz",
    yachtTour: "Yat Turu",
    cityTour: "Şehir Turu",
    mallTour: "AVM Turu",
    raftingTour: "Rafting Turu",
    helicopterTour: "Helikopter Turu",
    vipTransfer: "VIP Transfer",

    // Contact
    getInTouch: "İletişime Geçin",
    yourName: "Adınız",
    yourEmail: "E-posta Adresiniz",
    yourMessage: "Mesajınız",
    sendMessage: "Mesaj Gönder",

    // Agency Form
    agencyFormTitle: "Acenta Başvuru Formu",
    agencyFormDesc: "SunKiss ile çalışmak için aşağıdaki formu doldurun",
    agencyName: "Acenta Adı",
    contactPerson: "Yetkili Kişi",
    phone: "Telefon",
    email: "E-posta",
    address: "Adres",
    submit: "Gönder",

    // Footer
    aboutUs: "Hakkımızda",
    quickLinks: "Hızlı Linkler",
    followUs: "Bizi Takip Edin",
    allRightsReserved: "Tüm hakları saklıdır",
  },
  en: {
    // Navbar
    home: "Home",
    travelAgency: "Travel Agency",
    onlineReservation: "Online Reservation",
    agencyForm: "Agency Form",
    hotels: "Hotels",
    international: "International",
    services: "Our Services",
    contact: "Contact",
    dubai: "Dubai",
    cyprus: "Cyprus",

    // Home Page
    heroTitle: "Discover Your Dream Vacation with SunKiss",
    heroSubtitle:
      "Create unforgettable memories in Turkey's most beautiful destinations and Antalya",
    exploreMore: "Explore More",
    featuredHotels: "Featured Hotels",
    popularDestinations: "Popular Destinations",
    viewDetails: "View Details",

    // Hotels
    selectCity: "Select City",
    hotelsIn: "Hotels in",
    perNight: "Per Night",
    stars: "Stars",

    // Dubai
    dubaiSpecial: "Dubai Special",
    dubaiSubTitle:
      "Make unforgettable memories in Dubai's most beautiful destinations",
    dubaiHotels: "Dubai Hotels",
    dubaiTours: "Dubai Tours",
    dubaiTransfer: "Dubai Transfer",
    dubaiVisa: "Dubai Visa",

    // Cyprus
    cyprusSpecial: "Cyprus Special",
    cyprusSubTitle:
      "Make unforgettable memories in Cyprus's most beautiful destinations",
    cyprusHotels: "Cyprus Hotels",
    cyprusTours: "Cyprus Tours",
    cyprusTransfer: "Cyprus Transfer",
    cyprusVisa: "Cyprus Visa",

    // Services
    ourServices: "Our Services",
    yachtTour: "Yacht Tour",
    cityTour: "City Tour",
    mallTour: "Mall Tour",
    raftingTour: "Rafting Tour",
    helicopterTour: "Helicopter Tour",
    vipTransfer: "VIP Transfer",

    // Contact
    getInTouch: "Get In Touch",
    yourName: "Your Name",
    yourEmail: "Your Email",
    yourMessage: "Your Message",
    sendMessage: "Send Message",

    // Agency Form
    agencyFormTitle: "Agency Application Form",
    agencyFormDesc: "Fill out the form below to work with SunKiss",
    agencyName: "Agency Name",
    contactPerson: "Contact Person",
    phone: "Phone",
    email: "Email",
    address: "Address",
    submit: "Submit",

    // Footer
    aboutUs: "About Us",
    quickLinks: "Quick Links",
    followUs: "Follow Us",
    allRightsReserved: "All rights reserved",
  },
  de: {
    // Navbar
    home: "Startseite",
    travelAgency: "Reisebüro",
    onlineReservation: "Online-Reservierung",
    agencyForm: "Agenturformular",
    hotels: "Hotels",
    international: "International",
    services: "Unsere Dienstleistungen",
    contact: "Kontakt",
    dubai: "Dubai",
    cyprus: "Zypern",

    // Home Page
    heroTitle: "Entdecken Sie Ihren Traumurlaub mit SunKiss",
    heroSubtitle:
      "Schaffen Sie unvergessliche Erinnerungen an den schönsten Reisezielen der Türkei und in Antalya",
    exploreMore: "Mehr erfahren",
    featuredHotels: "Ausgewählte Hotels",
    popularDestinations: "Beliebte Reiseziele",
    viewDetails: "Details anzeigen",

    // Hotels
    selectCity: "Stadt wählen",
    hotelsIn: "Hotels in",
    perNight: "Pro Nacht",
    stars: "Sterne",

    // Dubai
    dubaiSpecial: "Dubai Spezial",
    dubaiSubTitle:
      "Sammeln Sie unvergessliche Erinnerungen an den schönsten Reisezielen in Dubai",
    dubaiHotels: "Dubai Hotels",
    dubaiTours: "Dubai Touren",
    dubaiTransfer: "Dubai Transfer",
    dubaiVisa: "Dubai Visum",

    // Cyprus
    cyprusSpecial: "Zypern Spezial",
    cyprusSubTitle:
      "Sammeln Sie unvergessliche Erinnerungen an den schönsten Reisezielen in Zypern",
    cyprusHotels: "Zypern Hotels",
    cyprusTours: "Zypern Touren",
    cyprusTransfer: "Zypern Transfer",
    cyprusVisa: "Zypern Visum",

    // Services
    ourServices: "Unsere Dienstleistungen",
    yachtTour: "Yachttour",
    cityTour: "Stadtrundfahrt",
    mallTour: "Einkaufszentrum-Tour",
    raftingTour: "Rafting-Tour",
    helicopterTour: "Hubschrauber-Tour",
    vipTransfer: "VIP-Transfer",

    // Contact
    getInTouch: "Kontaktieren Sie uns",
    yourName: "Ihr Name",
    yourEmail: "Ihre E-Mail",
    yourMessage: "Ihre Nachricht",
    sendMessage: "Nachricht senden",

    // Agency Form
    agencyFormTitle: "Agentur-Bewerbungsformular",
    agencyFormDesc:
      "Füllen Sie das Formular aus, um mit SunKiss zusammenzuarbeiten",
    agencyName: "Agenturname",
    contactPerson: "Ansprechpartner",
    phone: "Telefon",
    email: "E-Mail",
    address: "Adresse",
    submit: "Senden",

    // Footer
    aboutUs: "Über uns",
    quickLinks: "Schnelle Links",
    followUs: "Folgen Sie uns",
    allRightsReserved: "Alle Rechte vorbehalten",
  },
  ru: {
    // Navbar
    home: "Главная",
    travelAgency: "Турагентство",
    onlineReservation: "Онлайн бронирование",
    agencyForm: "Форма агентства",
    hotels: "Отели",
    international: "Международный",
    services: "Наши услуги",
    contact: "Контакты",
    dubai: "Дубай",
    cyprus: "Кипр",

    // Home Page
    heroTitle: "Откройте отпуск мечты с SunKiss",
    heroSubtitle:
      "Создайте незабываемые воспоминания в самых красивых местах Турции и Анталии",
    exploreMore: "Узнать больше",
    featuredHotels: "Избранные отели",
    popularDestinations: "Популярные направления",
    viewDetails: "Подробнее",

    // Hotels
    selectCity: "Выберите город",
    hotelsIn: "Отели в",
    perNight: "За ночь",
    stars: "Звезды",

    // Dubai
    dubaiSpecial: "Специальное предложение Дубай",
    dubaiSubTitle:
      "Создайте незабываемые воспоминания в самых красивых местах Дубая",
    dubaiHotels: "Отели Дубая",
    dubaiTours: "Туры по Дубаю",
    dubaiTransfer: "Трансфер в Дубае",
    dubaiVisa: "Виза в Дубай",

    // Cyprus
    cyprusSpecial: "Специальное предложение Кипр",
    cyprusSubTitle:
      "Создайте незабываемые воспоминания в самых красивых местах Кипра",
    cyprusHotels: "Отели Кипра",
    cyprusTours: "Туры по Кипру",
    cyprusTransfer: "Трансфер на Кипре",
    cyprusVisa: "Виза на Кипр",

    // Services
    ourServices: "Наши услуги",
    yachtTour: "Яхт-тур",
    cityTour: "Городская экскурсия",
    mallTour: "Тур по торговому центру",
    raftingTour: "Рафтинг-тур",
    helicopterTour: "Вертолетная экскурсия",
    vipTransfer: "VIP трансфер",

    // Contact
    getInTouch: "Свяжитесь с нами",
    yourName: "Ваше имя",
    yourEmail: "Ваш email",
    yourMessage: "Ваше сообщение",
    sendMessage: "Отправить сообщение",

    // Agency Form
    agencyFormTitle: "Форма заявки агентства",
    agencyFormDesc: "Заполните форму ниже, чтобы работать с SunKiss",
    agencyName: "Название агентства",
    contactPerson: "Контактное лицо",
    phone: "Телефон",
    email: "Email",
    address: "Адрес",
    submit: "Отправить",

    // Footer
    aboutUs: "О нас",
    quickLinks: "Быстрые ссылки",
    followUs: "Следуйте за нами",
    allRightsReserved: "Все права защищены",
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en");

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
